function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M47.326 34.953V51.8h-5.788v-4.492H15.447V51.8H9.658V34.953",
  stroke: "#FB4246",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.45 34.953v6.739h26.09v-6.739M55.621 15.255H1.28v15.897h54.343V15.255zM10.437 15.6L1.625 29.943M17.955 15.6L8.45 30.807M28.84 15.6l-9.59 15.206M36.873 15.6l-9.59 15.206M47.931 15.6l-9.503 15.206M55.535 16.119l-9.244 14.687M44.217 9.985a4.492 4.492 0 100-8.985 4.492 4.492 0 000 8.985zM12.684 9.985a4.492 4.492 0 100-8.985 4.492 4.492 0 000 8.985z",
  stroke: "#FB4246",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

function SvgUnavailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 53,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgUnavailable;